import CustomTable from "../../../../components/common/Table/CustomTable";
import { columInstallment, renderColumns } from "../constants";
import { Input } from "antd";
import { Link } from "react-router-dom";
import AppRoutePath from "../../../../router/AppRoutePath";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import httpclient from "../../../../components/httpclient";
import SwalToast from "../../../../components/helpers/SwalToast";
import {
  CanAccess,
  AuthorizationList,
} from "../../../../components/template/authorization/Authorization";
import ButtonInput from "../../../../components/common/Button/ButtonInput";

export default function LoanInstallment({
  data,
  loading,
  tablePagination,
  getData,
  handleTableChange,
  handleEnter,
  handleOutletButtonClick,
}) {
  const history = useHistory();
  const handleEdit = (record) => {
    history.push({
      pathname: AppRoutePath.CAMPAIGN_INSTALLMENT_ADD_OFFER,
      state: { data: record },
    });
  };

  const handleDelete = (record) => {
    let url = `${process.env.REACT_APP_BASE_API_URL}promo-loan/${record.item.id}`;

    Swal.fire({
      title: "Hapus Data",
      text: "Apakah anda yakin ingin menghapus Promo " + record.campaignName,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Hapus",
      cancelButtonText: "Batal",
    }).then((result) => {
      if (result.isConfirmed) {
        httpclient
          .DELETE(url)
          .then((response) => {
            SwalToast.fire({
              icon: "success",
              title: response.data.message,
            });
            getData();
          })
          .catch((error) => {
            console.log(error);
            if (error.response) {
              SwalToast.fire({
                icon: "error",
                title: error.response.data.error.message,
              });
            } else {
              SwalToast.fire({
                icon: "error",
                title: "Whoops, something went wrong",
              });
            }
          });
      }
    });
  };

  return (
    <div style={{ marginTop: 24 }}>
      <div className="d-flex justify-content-between">
        <div className="mr-2">
          <div style={{ fontSize: 14, color: "#303030" }}>Nama Promo :</div>
          <Input
            onKeyDown={handleEnter && handleEnter("enter")}
            style={{
              marginTop: 8,
              width: "200px",
              borderRadius: 6,
              border: "0.75px solid #DCDCDC",
            }}
            name="name"
            placeholder="Nama Promo"
          />
        </div>

        <ButtonInput
          id={"outlet"}
          label={"Cabang/Outlet"}
          buttonText={"Nama Cabang"}
          onButtonClick={handleOutletButtonClick}
          variant={"outline-secondary"}
          width={"13%"}
        />
        <CanAccess
          role={AuthorizationList.create_promo_offer}
          yes={
            <div className="ml-auto d-flex align-items-center">
              <Link to={AppRoutePath.CAMPAIGN_INSTALLMENT_ADD_OFFER}>
                <button className="ml-3 btn border-438EBC bgc-2C465C text-white font-weight-semi-bold">
                  + Tambah Promo
                </button>
              </Link>
            </div>
          }
        />
      </div>
      <div style={{ marginTop: 24 }}>
        <CustomTable
          columns={columInstallment(handleEdit, handleDelete)}
          data={data}
          loading={loading}
          handleTableChange={handleTableChange}
          pagination={tablePagination}
          scrollX={2500}
        />
      </div>
    </div>
  );
}
